<template>
  <main id="app" class="main-screen-sec">
    <Header/>
    <div class="main-content">
      <router-view/>
    </div>
    <Footer/>
  </main>
</template>
<script>
import Header from "@/layout/app/partials/Header";
import Footer from "@/layout/app/partials/Footer";

export default {
  components: {Header,  Footer},
  async created() {

  }
}
</script>

<style>
.main-screen-sec {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  padding-top: 80px;
  min-height: calc(100vh - 80px);
  flex: 1;
  display: flex;
  flex-direction: column;
}

.main-content > * {
  flex: 1;
}
</style>